import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { withNamespaces } from 'react-i18next';
import ContentItemStyles from './ContentItem.styles';

const UnitItem = ({
  classes,
  name,
  length,
  width,
  height,
  weight,
  quantity,
  volume,
  density,
  klass,
  value,
  t
}) => (
  <div className={classes.root}>
    <p className={classnames(classes.detail, classes.name)}>{name}</p>
    <p className={classnames(classes.detail)}>
      <strong>{`${t('Length')}: `}</strong>
      {length}
    </p>
    <p className={classnames(classes.detail)}>
      <strong>{`${t('Width')}: `}</strong>
      {width}
    </p>
    <p className={classnames(classes.detail)}>
      <strong>{`${t('Height')}: `}</strong>
      {height}
    </p>
    <p className={classnames(classes.detail)}>
      <strong>{`${t('Unit Weight')}: `}</strong>
      {weight}
    </p>
    <p className={classnames(classes.detail)}>
      <strong>{`${t('Quantity')}: `}</strong>
      {quantity}
    </p>
    <p className={classnames(classes.detail)}>
      <strong>{`${t('Volume')}: `}</strong>
      {volume}
    </p>
    <p className={classnames(classes.detail)}>
      <strong>{`${t('Density')}: `}</strong>
      {density}
    </p>
    <p className={classnames(classes.detail)}>
      <strong>{`${t('Class')}: `}</strong>
      {klass}
    </p>
    <p className={classnames(classes.detail)}>
      <strong>{`${t('Total Value')}: `}</strong>
      {value}
    </p>
  </div>
);

UnitItem.propTypes = {
  name: PropTypes.string.isRequired,
  length: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  weight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  volume: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  density: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  klass: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export { UnitItem };
const translatedUnitItem = withNamespaces()(UnitItem);
export default withStyles(ContentItemStyles)(translatedUnitItem);
